document.addEventListener("DOMContentLoaded", function () {

  // find the product form
  const productFormItems = document.querySelectorAll("product-form-component form, form[action*='/cart/add']");

  productFormItems.forEach(productForm => {
    // Initialize Custom Dropdowns Interactive logic
    document.querySelectorAll('.custom-dropdown').forEach(drop => {
      const selected = drop.querySelector('.dropdown-selected');
      if (!selected) return;

      selected.addEventListener('click', function (e) {
        e.stopPropagation(); // prevent document click from closing it immediately

        // Close all other dropdowns
        document.querySelectorAll('.custom-dropdown').forEach(d => {
          if (d !== drop) d.classList.remove('open');
        });

        drop.classList.toggle('open');
      });

      drop.querySelectorAll('.dropdown-option').forEach(option => {
        option.addEventListener('click', function (e) {
          e.stopPropagation();
          selected.innerText = this.innerText;
          selected.dataset.value = this.dataset.value;
          drop.classList.remove('open');
        });
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function () {
      document.querySelectorAll('.custom-dropdown.open').forEach(drop => {
        drop.classList.remove('open');
      });
    });

    // Size type toggle logic (Standard vs Custom)
    document.querySelectorAll('input[name="size-type"]').forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.value === "standard") {
          document.querySelector('.standard-size-wrapper').style.display = "block";
          document.querySelector('.custom-size-wrapper').style.display = "none";
        } else if (this.value === "custom") {
          document.querySelector('.standard-size-wrapper').style.display = "none";
          document.querySelector('.custom-size-wrapper').style.display = "block";
        }
      });
    });

    // Size button selection logic
    document.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
      });
    });

    // Intercept FormData creation to cleanly inject our custom properties
    // This ensures product-form.js picks them up during its fetch request
    productForm.addEventListener("formdata", function (event) {
      const sizeTypeNode = document.querySelector('input[name="size-type"]:checked');
      if (!sizeTypeNode) return;

      const sizeType = sizeTypeNode.value;
      const formData = event.formData;

      if (sizeType === "standard") {
        const size = document.querySelector(".size-btn.active");
        const height = document.querySelector(".height-dropdown .dropdown-selected")?.dataset.value;

        if (size && size.dataset.size) {
          formData.append("properties[Size Type]", "Standard Size");
          formData.append("properties[Size]", size.dataset.size);
        }
        if (height) {
          formData.append("properties[Height]", height);
        }
      } else if (sizeType === "custom") {
        formData.append("properties[Size Type]", "Custom Size");

        const fields = document.querySelectorAll(".custom-field");
        for (const field of fields) {
          const label = field.querySelector("label")?.innerText.trim();
          const value = field.querySelector(".dropdown-selected")?.dataset.value;
          if (label && value) {
            formData.append(`properties[${label}]`, value);
          }
        }

        const height = document.querySelector(".height-dropdown .dropdown-selected")?.dataset.value;
        if (height) {
          formData.append("properties[Height]", height);
        }

        const optional = document.querySelectorAll(".optional-field");
        optional.forEach(field => {
          const label = field.querySelector("label")?.innerText.trim();
          const value = field.querySelector(".dropdown-selected")?.dataset.value;
          if (label && value) {
            formData.append(`properties[${label}]`, value);
          }
        });
      }

      console.log("Custom Product Size Properties injected into FormData");
    });

    // Form submit intercept logic to validate BEFORE product-form.js processes it
    // We attach to the submit button click using capture to run before anything else
    const submitButton = productForm.querySelector('[type="submit"], [name="add"]');
    if (submitButton) {
      submitButton.addEventListener("click", function (event) {

        const errorMsgEl = productForm.querySelector('.custom-size-error-message');
        if (errorMsgEl) {
          errorMsgEl.style.display = 'none';
          errorMsgEl.innerText = '';
        }

        const sizeTypeNode = document.querySelector('input[name="size-type"]:checked');

        if (!sizeTypeNode) {
          return;
        }

        const sizeType = sizeTypeNode.value;
        let isValid = true;
        let errorMessage = '';

        if (sizeType === "standard") {
          const size = document.querySelector(".size-btn.active");
          const height = document.querySelector(".height-dropdown .dropdown-selected")?.dataset.value;

          if (!size) {
            errorMessage = "Please select a size.";
            isValid = false;
          } else if (!height) {
            errorMessage = "Please select your height.";
            isValid = false;
          }
        } else if (sizeType === "custom") {
          const fields = document.querySelectorAll(".custom-field");

          for (const field of fields) {
            const label = field.querySelector("label")?.innerText.trim();
            const value = field.querySelector(".dropdown-selected")?.dataset.value;

            if (!value) {
              errorMessage = `Please select ${label}.`;
              isValid = false;
              break; // Stop checking further fields if one is invalid
            }
          }

          if (isValid) {
            const height = document.querySelector(".height-dropdown .dropdown-selected")?.dataset.value;

            if (!height) {
              errorMessage = "Please select your height.";
              isValid = false;
            }
          }
        }

        if (!isValid) {
          if (errorMsgEl) {
            errorMsgEl.innerText = errorMessage;
            errorMsgEl.style.display = 'block';
            errorMsgEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            // fallback just in case the wrapper isn't rendered
            alert(errorMessage);
          }
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return false;
        }
      }, true); // Use capture phase so this runs first
    }
  });

});
